<template functional>
  <div>
    <a href="#" @click="$options.show(props)">{{ props.row.CustomerQty }}</a>
  </div>
</template>

<script>
import store from "../../../../store/index";
export default {
  name: "customerLink",
  show(ops) {
    store.dispatch("getAllCustomer", {
      empresaid: ops.row.Empresaid
    });
  }
};
</script>
